import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import uniqBy from 'lodash/uniqBy';

const StoryList = ({ handleDeleteStory, stories, activeTab }) => {

  const storiesArray = stories && Object.keys(stories).map((story) => stories[story]);

  const groups = uniqBy(storiesArray, (e) => e.section);
  const sections = groups.map((item) => item.section);

  return (<section className={ activeTab === 'content' || activeTab === 'stories' ? 'tab-content is-enabled' : 'tab-content' }>
      { sections.length && sections.length > 0 && sections.map((section, index) => {
        return (
            <table style={ { marginBottom: '30px', width: '100%'} }>

            <tr>
              <th style={ { textAlign: 'left', width: '90px' } }>Sort Order</th>
              <th style={ { textAlign: 'left' } }>Title</th>
              <th style={ { textAlign: 'left', width: '90px' } }>Section</th>
              <th style={ { textAlign: 'left', width: '200px' } }>URL</th>
              <th style={ { textAlign: 'left', width: '90px' } }>Published</th>
              <th style={ { textAlign: 'left', width: '90px' } }>Modified</th>
              <th style={ { textAlign: 'center', width: '90px' } }>Actions</th>
            </tr>
              { stories && Object.keys(stories).map((story, index) => {
                return stories[story].section === section ? (
                    <tr key={ index }>
                      <td style={ { textAlign: 'center' } }>
                        { stories[story].order }
                      </td>
                      <td>
                        <Link style={ { margin: '8px 0' } } className="admin--project" to={`/admin/stories/${ story }`} key={ story }>
                          { stories[story].title }
                        </Link>
                      </td>
                      <td>
                        { stories[story].section }
                      </td>
                      <td>
                        { stories[story].path }
                      </td>
                      <td>
                        { stories[story].published }
                      </td>
                      <td>
                        { stories[story].modified }
                      </td>
                      <td align="center" style={ { textAlign: 'center' } }>
                        <img style={ { cursor: 'pointer', zIndex: 1000, display: 'inline', verticalAlign: '-12px' } } onClick={  (e) => handleDeleteStory(e, story) } src="data:image/svg+xml,%3Csvg%20fill%3D%22%23ab3029%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M6%2019c0%201.1.9%202%202%202h8c1.1%200%202-.9%202-2V7H6v12zM19%204h-3.5l-1-1h-5l-1%201H5v2h14V4z%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%0A%3C/svg%3E"  alt="Remove" />
                      </td>
                    </tr>
                ) : null
              })}
            </table>
        )
      })}

    <p>Add new { <Link to="admin/content">Content</Link> }.</p>

  </section>)
};

StoryList.propTypes = {
  stories: PropTypes.object,
  handleDeleteStory: PropTypes.func,
  activeTab: PropTypes.string
};

export default StoryList;



// WEBPACK FOOTER //
// ./src/containers/admin/StoryList.js